export default __webpack_public_path__ + "static/0248-c2464bb33d91779e63bb6c6f440e8d69.png";